// FILE: src/components/StreakCard.js
//
// Streak counter — current consecutive-day study streak plus a 14-dot
// history strip showing which days had sessions.
//
// Streak comes from streakService.deriveStreak(sessions).

import React from 'react';
import styles from './StreakCard.module.css';

export default function StreakCard({ streak }) {
  const days = streak?.days || 0;
  const history = Array.isArray(streak?.history) ? streak.history : [];

  return (
    <div className={styles.card} data-testid="dashboard-streak">
      <div className={styles.head}>🔥 Streak</div>
      <div className={styles.row}>
        <span className={styles.flame}>🔥</span>
        <div>
          <div className={styles.big}>
            {days} <span className={styles.bigSub}>{days === 1 ? 'day' : 'days'}</span>
          </div>
          <div className={styles.small}>{days > 0 ? 'Keep it going!' : 'Start a session to begin a streak.'}</div>
        </div>
      </div>
      {history.length > 0 && (
        <div className={styles.dots}>
          {history.slice(-7).map((on, i) => (
            <span key={i} className={on ? styles.dotOn : styles.dotOff} />
          ))}
        </div>
      )}
    </div>
  );
}
